import { combineReducers } from "redux";
import PostsReducer, {toggleMenu}  from '../../store/reducers/PostsReducer';

import { AuthReducer } from '../../store/reducers/AuthReducer';
import todoReducers from '../../store/reducers/Reducers';
// Front
// import LayoutReducer from "./layouts/reducer";

// Authentication
// import LoginReducer from "./auth/login/reducer";

import AccountReducer from "./auth/register/reducer";
import LoginReducer from "./auth/login/reducer";
import OtpReducer from "./auth/verify-otp/reducer";
import DietPlanReducer from "./diet/dietPan/reducer";
import workoutReducer from "./sport/workout/reducer";
import  exerciseCategoriesReducer from "./sport/categories_sport/reducer";
import  dataDashboardPlanReducer from "./data-dashboard/reducer";
import uploardReducer from "./document/reducer"


const rootReducer = combineReducers({
    // Layout: LayoutReducer,
    Account: AccountReducer,
    Login: LoginReducer,
    otp: OtpReducer,
    sideMenu: toggleMenu,
    posts: PostsReducer,
    auth: AuthReducer,
    DietPlan:DietPlanReducer,
		todoReducers,
    workout: workoutReducer,
    exerciseCategories: exerciseCategoriesReducer,
    dataDashboardPlan: dataDashboardPlanReducer, 
    uploard : uploardReducer
 
});

export default rootReducer;